export const LossReasonAndTypeOptions = [
  {
    value: 'denied',
    label: 'Denied',
    denied: [
      {
        value: 'atypical-property',
        label: 'Atypical property',
      },
      {
        value: 'avm-data',
        label: 'AVM Data',
      },
      {
        value: 'credit',
        label: 'Credit',
      },
      {
        value: 'home-value',
        label: 'Home Value',
      },
      {
        value: 'improper-property-use',
        label: 'Improper Property Use',
      },
      { value: 'ineligible-state', label: 'Ineligible state' },
      {
        value: 'not-enough-equity',
        label: 'Not enough equity',
      },
      {
        value: 'property-condition',
        label: 'Property condition',
      },
      { value: 'unacceptable-first-lien', label: 'Unacceptable first lien' },
      { value: 'unacceptable-vesting', label: 'Unacceptable vesting' },
      { value: 'unresolved-subordinations', label: 'Unresolved subordination(s)' },
      { value: 'unresolved-lien-releases', label: 'Unresolved lien release(s)' },
      { value: 'unresolved-payoffs', label: 'Unresolved payoff(s)' },
      { value: 'insufficient-insurance', label: 'Insufficient insurance' },
      { value: 'other', label: 'Other' },
    ],
  },
  {
    value: 'withdrawn',
    label: 'Withdrawn',
    withdrawn: [
      { value: 'different-hea', label: 'Chose different HEA' },
      { value: 'duplicate', label: 'Duplicate' },
      { value: 'incomplete-application', label: 'Incomplete application' },
      { value: 'no-longer-interested', label: 'No longer interested' },
      { value: 'offer-too-small', label: 'Offer too small' },
      { value: 'too-complex', label: 'Too complex' },
      { value: 'too-expensive', label: 'Too expensive' },
      { value: 'traditional-financing', label: 'Traditional financing' },
      { value: 'unresponsive', label: 'Unresponsive' },
      {
        value: 'other',
        label: 'Other',
      },
    ],
  },
]

export const subLossReasonsOptions = {
  'atypical-property': [
    { value: 'five_more_apt_building', label: '5+ Apt Building' },
    { value: 'atypical-home-size', label: 'Atypical Home Size' },
    { value: 'farm-livestock', label: 'Farm / Livestock' },
    { value: 'home-build-type', label: 'Home Build Type' },
    {
      value: 'home-under-construction-renovation',
      label: 'Home under construction / renovation',
    },
    { value: 'log-cabin', label: 'Log Cabin' },
    { value: 'lot-size', label: 'Lot Size' },
    { value: 'manufactured-mobile-home', label: 'Manufactured/Mobile Home' },
    { value: 'multiple-dwellings-on-parcel', label: 'Multiple Dwellings on Parcel' },
    { value: 'vacant-lot-land', label: 'Vacant Lot/Land' },
    { value: 'zoning', label: 'Zoning' },
  ],
  'avm-data': [
    { value: 'no-avm-data-available', label: 'No AVM Data Available' },
    { value: 'scarcity-of-comps-avm-data', label: 'Scarcity of Comps / AVM Data' },
  ],
  credit: [
    { value: 'bankruptcy', label: 'Bankruptcy' },
    { value: 'fico-less-than-500', label: 'FICO less than 500' },
    { value: 'mtg-dq-90-days', label: 'MTG DQ 90 Days' },
    { value: 'mtg-dq-120-days', label: 'MTG DQ 120 Days' },
    { value: 'mtg-dq-150-plus-days', label: 'MTG DQ 150+ Days' },
    { value: 'mtg-collection-or-charge-off', label: 'MTG Collection or Charge off' },
    { value: 'mtg-repo-or-fc', label: 'MTG Repo or FC' },
    { value: 'dti-over-45-percent', label: 'DTI over 45%' },
    { value: 'dscr-below-1-25x', label: 'DSCR below 1.25x' },
    { value: 'garnishment-or-attachment', label: 'Garnishment or attachment' },
    { value: 'limited-credit-experience', label: 'Limited credit experience' },
    { value: 'no-credit-file', label: 'No credit file' },
    {
      value: 'number-of-recent-inquiries-on-credit-bureau-report',
      label: 'Number of recent inquiries on credit bureau report',
    },
    {
      value: 'value-or-type-of-collateral-not-sufficient',
      label: 'Value or type of collateral not sufficient',
    },
  ],
  'home-value': [
    { value: 'above-guidelines', label: 'Above Guidelines' },
    { value: 'below-guidelines', label: 'Below Guidelines' },
  ],
  'improper-property-use': [
    { value: 'commercial-aspects', label: 'Commercial Aspects' },
    { value: 'unpermitted-rental', label: 'Unpermitted Rental' },
  ],
  'not-enough-equity': [{ value: 'not-enough-equity', label: 'Not enough equity' }],
  'property-condition': [{ value: 'home-condition', label: 'Home Condition' }],
  'unacceptable-vesting': [
    { value: 'title-held-in-llc', label: 'Title Held in LLC' },
    { value: 'title-held-in-life-estate', label: 'Title Held in Life Estate' },
    { value: 'title-held-in-tenants-in-common', label: 'Title Held in Tenants in Common' },
  ],
  other: [{ value: 'user-input-specified', label: 'User Input Specified' }],
}

export const AANDenialReasons = {
  'excessive-obligations': 'Excessive obligations in relation to income',
  'no-credit-file': 'No credit file',
  'limited-credit-experience': 'Limited credit experience',
  'delinquent-past': 'Delinquent past or present credit obligations with others',
  'collection-action-or-judgment': 'Collection action or judgment',
  'garnishment-or-attachment': 'Garnishment or attachment',
  'foreclosure-or-repossession': 'Foreclosure or repossession',
  bankruptcy: 'Bankruptcy',
  'collateral-not-sufficient': 'Value or type of collateral not sufficient',
  'inquiries-credit-bureau-report': 'Number of recent inquiries on credit bureau report',
  'fico-less-than-500': 'FICO less than 500',
}
